export type CloseCourierDialogDetail = {
    storeOrderId: string;
    deliveryteamOrderId: string;
};

export const courierRequestEvents = new EventTarget();

export const getCloseCourierDialogEventName = (storeOrderId: string) =>
    `${storeOrderId}-closeCourierDialog`;

export const dispatchCloseCourierDialog = (detail: CloseCourierDialogDetail) => {
    courierRequestEvents.dispatchEvent(
        new CustomEvent<CloseCourierDialogDetail>(
            getCloseCourierDialogEventName(detail.storeOrderId),
            { detail },
        ),
    );
};
